import { render, staticRenderFns } from "./SoftAndNeat.vue?vue&type=template&id=ddf2e0ce"
import script from "./SoftAndNeat.vue?vue&type=script&lang=js"
export * from "./SoftAndNeat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports